(function () {
    'use strict';

    angular
        .module('app')
        .directive('mediaGallery', mediaGallery);

    mediaGallery.$inject = ['$window'];

    function mediaGallery($window) {
        // Usage:
        //     <mediaGallery></mediaGallery>
        // Creates:
        // 
        var directive = {
            bindToController: true,
            controllerAs: '$mediaGallery',
            restrict: 'EA',
            templateUrl: "/static/Common/js/templates/mediaGallery/_mediaGallery.html",
            link: link
        };
        return directive;

        function link($scope, $element, $attrs) {
            var mediaAttributes = JSON.parse($attrs.asbMedia);
            
            $scope.mainCarousel = mediaAttributes[0].mediaItems[0];
            $scope.carousels = mediaAttributes[0].mediaItems;

            var isActiveItemSet = false;

            $scope.caption = $scope.mainCarousel.caption;

            $scope.getMedia = function (activeMedia) {
                if (activeMedia !== null && activeMedia !== undefined && activeMedia !== 'undefined') {
                    return activeMedia.mediaItems;
                } else {
                    return 'undefined';
                }
            }

            $scope.changeCaption = function (carouselItem) {
                if (carouselItem.caption !== '' && carouselItem.caption !== undefined) {
                    $scope.caption = carouselItem.caption;
                }
            }

            $scope.removeCarousel = function () {
                $('.zoom-item').owlCarousel('destroy');

                $('.cloud-zoom').data('zoom').destroy();
                if ($('.cloud-zoom').parent("#wrap").length) {
                    $('.cloud-zoom').unwrap();
                }

                $scope.caption = $scope.mainCarousel.caption;
                $scope.carousels = mediaAttributes[0].mediaItems;

                var mainProductCarousel = {
                    url: mediaAttributes[0].mediaItems[0].url,
                    caption: mediaAttributes[0].mediaItems[0].caption
                };

                $scope.mainCarousel = mainProductCarousel;
                $scope.initializeCarousel(300);
            }

            $scope.setCarousels = function (mediaItems) {
                $scope.carousels = _.concat($scope.mainCarousel, mediaItems);
                $scope.caption = $scope.mainCarousel.caption;

                $('.zoom-item').owlCarousel('destroy');

                if ($('.cloud-zoom').parent("#wrap").length) {
                    $('.cloud-zoom').data('zoom').destroy();
                    $('.cloud-zoom').unwrap();
                }

                $scope.initializeCarousel(200);
            }

            $scope.$on('getActiveItem', function (event, args) {
                if (args[0] !== null && args[0] !== 'undefined') {

                    for (var i = 0; i < mediaAttributes.length; i++) {
                        var mediaAttribute = mediaAttributes[i];

                        if (mediaAttribute.itemId === args[0].id) {
                            $scope.setActiveMedia = mediaAttribute;

                            var mediaItems = $scope.getMedia($scope.setActiveMedia);
                            if (mediaItems !== 'undefined') {
                                $scope.setCarousels(mediaItems);
                            }
                        }
                    }
                    isActiveItemSet = true;
                } else {
                    if (isActiveItemSet) {
                        $scope.removeCarousel();
                        isActiveItemSet = false;
                    }
                }
            });

            $scope.initializeCarousel = function (timeout) {
                setTimeout(function () {
                    $('.cloud-zoom, .cloud-zoom-gallery, .video-thumbnail').CloudZoom();

                    $('.zoom-item').owlCarousel({
                        loop: false,
                        nav: false,
                        margin: 10,
                        items: 5,
                        responsiveClass: true,
                        responsive: {
                            0: {
                                items: 4
                            },
                            992: {
                                items: 5
                            }
                        }
                    });
                }, timeout);
            }

            $scope.initializeCarousel(1000);
        }
    }

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/templates/mediaGallery/_mediaGallery.js
// module id = 16
// module chunks = 0